import { atom } from 'recoil';
import type { ContourModelChoice } from '~/state/atoms/adaptiveReplanningAtoms';

type ContourPropagationTaskState = {
    propagationModelName?: string;
    roiPlan?: Record<
        string,
        {
            included: boolean;
            source: 'propagate' | 'contour';
            confirmedModelRoiName?: string;
        }
    >;
    comparisonModel?: ContourModelChoice;
    // Set once the user picks the Contour+ model; the best match then leaves the pick alone.
    comparisonModelChosen?: boolean;
    initRigid?: { enabled: boolean; sopInstanceUid?: string };
};

export const contourPropagationTaskState = atom<ContourPropagationTaskState>({
    key: 'contourPropagationTaskState',
    default: {},
});
